export enum SpecialFlagTypeEnum {
  Uploaded = 'Uploaded',
  GetPaperwork = 'Get Paperwork',
  NeedsApproval = 'Needs Approval',
  EFSIssued = 'EFS Issued',
  QueueRefund = 'Refund Request',
  MissingPaperwork = 'Missing Paperwork',
}
